<template>
  <validation-observer ref="formAddCampaign" #default="{ invalid }">
    <b-form @submit.prevent="formSubmitted">
      <div class="d-flex justify-content-center mb-1" v-if="mainLoading">
        <b-spinner
          variant="success"
          label="Spinning"
          block
          style="width: 3rem; height: 3rem"
        ></b-spinner>
      </div>
      <b-row v-if="!mainLoading">
        <b-col md="6">
          <!-- {{ emailId }} -->
          <b-form-group label="Campaign Id" label-for="campaign_id">
            <b-form-input
              placeholder="Campaign Id"
              readonly
              v-model="emailId.id"
              name="campaign_id"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Campaign Name" label-for="campaign_name">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="campaign name"
              vid="Campaign Name"
            >
              <b-form-input
                placeholder="Campaign Name"
                v-model="emailId.name"
                name="campaign_name"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Start Date" label-for="start_date">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="start date"
              vid="Start Date"
            >
              <b-form-datepicker
                id="start_date"
                placeholder="Choose a date"
                local="en"
                initial-date="2024-06-16"
                v-model="emailId.startDate"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="End Date" label-for="end_date">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="end date"
              vid="End Date"
            >
              <b-form-datepicker
                id="end_date"
                placeholder="Choose a date"
                local="en"
                initial-date="2024-06-16"
                v-model="emailId.endDate"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Email Template" label-for="email_template">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="email template"
              vid="Email Template"
            >
              <b-form-select
                v-model="selectedTemplateId"
                :options="emailtemplatelist"
                @change="selectTemplate"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider></b-form-group
          ></b-col
        >
        <b-col md="6">
          <b-form-group label="Subject" label-for="subject">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="subject"
              vid="Subject"
            >
              <b-form-input
                placeholder="Subject"
                name="subject"
                v-model="emailId.subject"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Segment" label-for="segment">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="segment"
              vid="Segment"
            >
              <v-select
                v-model="selectedSegments"
                :options="segmentOptions"
                multiple
                label="itemTitle"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider></b-form-group
          ></b-col
        >
        <b-col md="6">
        <b-form-group label="Status" label-for="status">
          <b-form-select
                v-model="emailId.status"
                :options="statusOptions"
                disabled
              /> </b-form-group
      ></b-col>

      <b-col md="6">
          <b-form-group label="SMTP Setting" label-for="email_smtp">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="SMPT setting"
              vid="SMPT Setting"
            >
              <b-form-select
                v-model="emailId.smtpSettingId"
                :state="errors.length > 0 ? false : null"
                :options="smtp"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Email Content" label-for="email_content">
            {{ selectedTemplate }}
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="email content"
              vid="Email Content"
            >
              <quill-editor v-model="selectedTemplate.body" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider></b-form-group
          >
        </b-col>

        <b-col md="12">
          <div class="demo-inline-spacing">
            <b-form-radio v-model="SelectedRadio" name="radio1" value="D">
              Save as Draft
            </b-form-radio>
            <b-form-radio v-model="SelectedRadio" name="radio1" value="A">
              Send Now
            </b-form-radio>
            <b-form-radio v-model="SelectedRadio" name="radio1" value="B">
              Schedule Sending
            </b-form-radio>
          </div>
        </b-col>

        <!-- date and time -->
        <b-col md="12" class="mt-2" v-if="SelectedRadio === 'B'">
          <b-form-group>
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="date and time"
              vid="dateNtim"
            >
              <h5>Date & Time</h5>
              <b-form-datepicker
                v-model="dateNtim"
                id="form-control"
                placeholder="Choose a date"
                local="en"
                :initial-date="new Date()"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <div class="demo-inline-spacing">
            <b-button
              v-if="showSaveDraft"
              @click="saveDraft"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="warning"
            >
              Save as Draft
            </b-button>
            <b-button
              v-if="showSaveScheduled"
              @click="saveScheduled"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="info"
            >
              Schedule
            </b-button>
            <b-button
              v-if="showSendNow"
              @click="sendNow"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
            >
              Send Now
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
  BFormFile,
  BFormRadio,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import { required, email } from "@validations";
import { quillEditor } from "vue-quill-editor";
import {
  getProviderName,
  createProvider,
  deleteProvider,
  getProviders,
  testsmtp,
  updateProvider,
} from "@/store/smtp/services";
import campaign from "@/store/campaign";

export default {
  name: "EditCampaign",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BFormRadio,
    vSelect,
    quillEditor,
    flatPickr,
  },
  data() {
    return {
      id: this.$route.params.id,
      mainLoading: false,
      emailtemplatelist: [],
      selectedTemplateId: null,
      selectedTemplate: [],
      segmentOptions: [],
      selectedSegments: [],
      Selected: "A",
      Selected1: "c",
      SelectedRadio: "D",
      dateNtim: null,
      campaign: {
        id: "",
        name: "",
        startDate: null,
        endDate: null,
        templateId: "",
        content: "",
        segmentId: [],
        description: "",
        
      },
      smtp: [],
      statusOptions:[
        {value:"DRAFT",text:"DRAFT"},
        {value:"SCHEDULED",text:"SCHEDULED"},
        {value:"COMPLETED",text:"COMPLETED"},
        {value:"CANCELLED",text:"CANCELLED"}
      ],
    };
  },
  computed: {
    ...mapGetters("emailtemplate", {
      emailtemplate: "emailtemplate",
      loading: "loading",
    }),
    ...mapGetters("segmentModule", {
      segments: "segments",
      loading: "loading",
    }),
    ...mapGetters("emailcampaign", {
      emailcampaign: "emailcampaign",
      emailId: "emailcampaignid",
      loading: "loading",
    }),
    showSaveDraft() {
      return this.SelectedRadio === "D";
    },
    showSaveScheduled() {
      return this.SelectedRadio === "B";
    },
    showSendNow() {
      return this.SelectedRadio === "A";
    },
  },
  methods: {
    ...mapActions("segmentModule", ["getSegmentsAction"]),
    ...mapActions("emailtemplate", ["getEmailTemplateListAction"]),
    ...mapActions("emailcampaign", [
      "addEmailCampaignAction",
      "getEmailCampaignByIdAction",
      "updateEmailCampaignAction",
    ]),
    selectTemplate() {
      this.selectedTemplate = this.emailtemplate.find(
        (template) => template.templateId === this.selectedTemplateId
      );
    },
    success(message) {
      this.$swal({
        title: "Email Campaign Updated!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },
    async formSubmitted(status) {
       // Validate the form if status is not 'DRAFT'
       if (status !== "DRAFT") {
        const isValid = await this.$refs.formAddCampaign.validate();
        if (!isValid) {
          // Handle invalid form
          return;
        }
      }
      // confirm update
      const result = await this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this Campaign!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, update it!",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      });
      const payload = {
        name: this.emailId.name,
        startDate: this.emailId.startDate,
        endDate: this.emailId.endDate,
        subject: this.emailId.subject,
        content: this.selectedTemplate.body,
        body: this.selectedTemplate.body,
        description: this.emailId.description,
        status: status,
        templateId: this.selectedTemplateId,
        segmentId: this.selectedSegments.map((segment) => segment.value),
        campaignDrafts: [
          {
            content: this.selectedTemplate.body,
            scheduledPublishedDate:
              this.SelectedRadio === "B" ? this.dateNtim : null,
            segmentId: this.selectedSegments.map((segment) => segment.value),
            id: this.emailId.id,
          },
        ],
        smtpSettingId: this.emailId.smtpSettingId,
        emailCampaignId: this.emailId.id,
      };
      console.log("payload", payload);
      if (result.isConfirmed) {
        let loader = this.$swal({
          title: "Processing...",
          text: "Please wait while the Campaign is being updated",
          onOpen: () => {
            this.$swal.showLoading();
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
          buttonsStyling: false,
          showConfirmButton: false,
        });
        try {
          console.log("payloadddddd", payload);
          await this.updateEmailCampaignAction(payload);
          loader.close();
          this.success();
          this.$router.push({ name: "email-list" });
        } catch (error) {
          loader.close();
          this.error(error);
        } finally {
          await this.fetchCampaignDetails();
        }
      } else {
        await this.fetchCampaignDetails();
      }
      this.$router.push({ name: "email-list" });
    },
    saveDraft() {
      this.formSubmitted("DRAFT");
    },
    saveScheduled() {
      if(this.dateNtim === null){
        this.errordateNtime();
         return;
      }
      if (this.SelectedRadio === "B" && this.dateNtim) {
        this.formSubmitted("SCHEDULED");
      } else {
        this.formSubmitted("DRAFT");
      }
    },

    sendNow() {
      if (this.SelectedRadio === "A") {
        this.formSubmitted("COMPLETED");
      }
    },

    errordateNtime() {
      this.$swal({
        title: "Error!",
        text: " Please select a date!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    
    async fetchCampaignDetails() {
      this.mainLoading = true;
      try {
        await this.getEmailTemplateListAction().then(() => {
          this.emailtemplatelist = this.emailtemplate.map((template) => ({
            value: template.templateId,
            text: `${template.name}`,
          }));
        });

        await this.getSegmentsAction().then(() => {
          this.segmentOptions = this.segments.map((segment) => ({
            value: segment.segmentId,
            itemTitle: `${segment.name}`,
          }));
        });
        await this.getEmailCampaignByIdAction(this.id);
        this.selectedTemplateId = this.emailId.emailTemplate.templateId;
        this.selectedTemplate = this.emailtemplate.find(
          (template) => template.templateId === this.selectedTemplateId
        );
        // Set selected segments
        this.selectedSegments = this.emailId.segmentId
          .map((id) => {
            const segment = this.segments.find(
              (segment) => segment.segmentId === id
            );
            return segment
              ? { value: segment.segmentId, itemTitle: segment.name }
              : null;
          })
          .filter((segment) => segment !== null);
      } catch (error) {
        this.error(error);
      } finally {
        this.mainLoading = false;
      }
    },


    async getSMPT() {
      try {
        const response = await getProviders();
        this.smtp = response.data.result.map((smtp) => ({
          value: smtp.id,
          text: `${smtp.provider}`,
        }));
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    await this.fetchCampaignDetails();
    await this.getSMPT();
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>
